/**
 * @ngdoc directives
 * @memberof mercury.directives
 * @name icon-company
 * @description Displays the Help icon
 */
angular.module('mercury.directives.icon-help', [])
.directive('iconHelp', function() {
  return {
    restrict: 'E',
    template: '<svg class="svg-icon-root" focusable="false" viewBox="0 0 24 24">' +
                '<path d="M24 12C24 18.6289 18.6269 24 12 24C5.37308 24 0 18.6289 0 12C0 5.37499 5.37308 0 12 0C18.6269 0 24 5.37499 24 12ZM12.3221 3.96774C9.68507 3.96774 8.00323 5.07856 6.68255 7.05281C6.51145 7.30858 6.56869 7.65353 6.81392 7.83948L8.49291 9.11255C8.74476 9.30354 9.10359 9.25809 9.29927 9.00988C10.1637 7.91352 10.7563 7.27776 12.0721 7.27776C13.0605 7.27776 14.2831 7.91396 14.2831 8.87251C14.2831 9.59714 13.6851 9.96929 12.7089 10.5165C11.5708 11.1546 10.0646 11.9488 10.0646 13.9355V14.129C10.0646 14.4498 10.3245 14.7097 10.6452 14.7097H13.3548C13.6756 14.7097 13.9355 14.4498 13.9355 14.129V14.0646C13.9355 12.6874 17.9606 12.63 17.9606 8.90322C17.9606 6.09667 15.0494 3.96774 12.3221 3.96774ZM12 15.9677C10.7727 15.9677 9.77419 16.966 9.77419 18.1935C9.77419 19.4208 10.7727 20.4193 12 20.4193C13.2274 20.4193 14.2258 19.4208 14.2258 18.1935C14.2258 16.966 13.2274 15.9677 12 15.9677Z" />' +
              '</svg>',
    }
  })
